const CSP_ARTICLE_PREFIX = ['#/article/', '#/articles/', '#/myTrips'];
export const isFromOldCspLink = () => {
  return CSP_ARTICLE_PREFIX.some((subStr) => window.location.hash.startsWith(subStr));
};

export const getCurrentCspArticleId = () => {
  const hash = window.location.hash;
  return hash.substring(hash.lastIndexOf('/') + 1, hash.length);
};
